import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    ShortName: z.string().min(1, "Short Name is required"),
    Headquarters: z.string().optional(),
    Founded: z.string().optional(),
    Industry: z.string().optional(),
    Website: z
        .string()
        .optional()
        .refine((val) => !val || val === "" || z.string().url().safeParse(val).success, {
            message: "Please enter a valid URL",
        }),
    Status: z.string().optional(),
});

const newManufacturerResolver = zodResolver(schema);

export default newManufacturerResolver;
